import './UserChangePassword.css';

import { Box } from '@mui/material';
import { useContext, useState } from 'react';
import useB2BTranslation from '../../../b2b-common/hooks/useB2BTranslation';
import EditText from '../../../b2b-common/EditText';
import CustomButton from '../../../b2b-common/CustomButton';
import { showNotification } from '../../../b2b-common/Notification';
import { changeLoggedUserPassword } from '../../../../services/b2b-users-apiService';
import { useLoginContext } from '../../../../App';
import { B2BContentContext } from '../../../layout/Layout';
import useLogout from '../../../layout/hooks/useLogout';

const UserChangePassword = () => {
    const { loginData } = useLoginContext();
    const { t } = useB2BTranslation('b2b-users');
    const handleLogout = useLogout();
    const { setNotification } = useContext(B2BContentContext);
    const [passwordForm, setPasswordForm] = useState(
        { currentPassword: '', newPassword: '', newPasswordRepeat: '' });
    const [isChangingPassword, setIsChangingPassword] = useState(false);

    const handleChangePassword = async () => {
        if (passwordForm.newPassword !== passwordForm.newPasswordRepeat) {
            showNotification(setNotification, t('New Password do not match'), 'error', 3000);
            return;
        }
        try {
            setIsChangingPassword(true);
            await changeLoggedUserPassword(passwordForm.currentPassword, passwordForm.newPassword, loginData.accessToken);
            showNotification(setNotification, t('Password changed successfully'), 'success', 3000);
            await new Promise(resolve => setTimeout(resolve, 3000));
            handleLogout();
        } catch (error) {
            console.error('Error changing password', error);
            showNotification(setNotification, t('Error changing password'), 'error', 5000);
        } finally {
            setIsChangingPassword(false);
        }
    }

    return (
        <Box className={'user-change-password'} width={'50%'} p={0} display={'flex'} flexDirection={'column'} gap={2} >
            <EditText object={passwordForm} objectField={'currentPassword'} setObjectField={setPasswordForm} label={t('Current password')} type={'password'} />
            <EditText object={passwordForm} objectField={'newPassword'} setObjectField={setPasswordForm} label={t('New password')} type={'password'} />
            <EditText object={passwordForm} objectField={'newPasswordRepeat'} setObjectField={setPasswordForm} label={t('Repeat new password')} type={'password'} />
            <CustomButton label={t('Change password')} onClick={handleChangePassword} disabled={isChangingPassword} />
        </Box>
    )
};

export default UserChangePassword;